export const maxAgeOdchod = 18;

export const getSchoolYears = (date:Date) => {

    const years: number[] = [];    
    const month = date.getMonth()+1;
    const year = date.getFullYear();    
    if (month>7) {
        years.push(year);
    }
    else {
        years.push(year-1);
    }
    if (month == 7) {
        years.push(year);
    }
    return years;
}
